(function () {
  'use strict';
  var intelligence = window.CKB_MPAS_DEPLOYMENT_INTELLIGENCE;
  if (!intelligence || !intelligence.builder) return;

  var parts = intelligence.builder.parts || (intelligence.builder.parts = {});
  var recipes = intelligence.builder.recipes || (intelligence.builder.recipes = {});

  function part(key, name, query, componentId) {
    parts[key] = { name: name, query: query, component_id: componentId };
  }
  function recipe(key, name, required, notes) {
    recipes[key] = {
      name: name,
      source: 'Controlled Chameleon guides and owner-confirmed configuration rules · 15AUG2026',
      required: required,
      notes: notes
    };
  }

  part('cap-hat', 'CHA CAP HAT', 'CHA CAP HAT', 'MPAS-CMP-CAPHAT');
  part('lz-sloper', 'CHA LZ SLOPER WIRE', 'CHA LZ SLOPER WIRE', 'MPAS-CMP-LZ');
  part('ss58', 'CHA SS58', 'CHA SS58', 'MPAS-CMP-SS58');
  part('porta-mast', 'CHA PORTA-MAST · 15, 20 or 25 ft', 'CHA PORTA-MAST', 'MPAS-CMP-PORTAMAST');
  part('porta-mast-adapter', 'CHA PORTA-MAST ADAPTER', 'CHA PORTA-MAST ADAPTER', 'MPAS-CMP-PORTAMAST-ADAPTER');
  part('porta-top-mount', 'CHA PORTA-MAST TOP MOUNT', 'CHA PORTA-MAST TOP MOUNT', 'MPAS-CMP-PORTAMAST-TOP');
  part('porta-side-mount', 'CHA PORTA-MAST SIDE MOUNT', 'CHA PORTA-MAST SIDE MOUNT', 'MPAS-CMP-PORTAMAST-SIDE');
  part('porta-hitch-mount', 'CHA HITCH MOUNT', 'CHA HITCH MOUNT', 'MPAS-CMP-PORTAMAST-HITCH');
  part('porta-wheel-mount', 'CHA WHEEL MOUNT', 'CHA WHEEL MOUNT', 'MPAS-CMP-PORTAMAST-WHEEL');

  // Direct-fed stationary-vehicle recipes are intentionally withheld. The CHA
  // HITCH MOUNT and CHA WHEEL MOUNT are PORTA-MAST bases; neither exposes a
  // 3/8-24 antenna interface. A future vehicle recipe must name the complete
  // mast/support/adapter chain before it can become executable.

  ['mpas2', 'mpas-lite'].forEach(function (parent) {
    ['ss17', 'ss25'].forEach(function (whip) {
      ['mini', 'micro'].forEach(function (hybridSize) {
        var hybrid = 'hybrid-' + hybridSize;
        var id = hybridSize === 'mini' ? parent + '-lz-' + whip : parent + '-micro-lz-' + whip;
        recipe(id,
          'CHA ' + hybrid.toUpperCase() + ' + CHA ' + whip.toUpperCase() + ' + LZ SLOPER WIRE · ' + (parent === 'mpas2' ? 'MPAS 2.0' : 'MPAS Lite') + ' component reference',
          { [hybrid]: 1, [whip]: 1, 'lz-sloper': 1 },
          [
            'This record names the actual feed and radiator components. The complete retail antenna system is not an additional component in the recipe.',
            'The LZ SLOPER WIRE is a 60 ft auxiliary radiator attached and strain-relieved at the tip of the SS17 or SS25.',
            'Deploy as the documented sloper/lazy-L. Record wire bearing and endpoint height; a sagging end near 3 ft is a documented starting point.',
            'The LZ SLOPER WIRE is approved only with CHA MPAS 2.0 or CHA MPAS LITE. It is not a standalone antenna and is not approved with BV or PRV systems.',
            'Its added conductor changes current distribution and the pattern on every operating band; do not substitute a bare-whip NEC case.'
          ]);
      });
    });
  });

  ['ss17', 'ss25'].forEach(function (whip) {
    ['mini', 'micro'].forEach(function (hybridSize) {
      var hybrid = 'hybrid-' + hybridSize;
      var id = hybridSize === 'mini' ? 'mpas2-mil-ext-lz-' + whip : 'mpas2-micro-mil-ext-lz-' + whip;
      recipe(id,
        'CHA ' + hybrid.toUpperCase() + ' + CHA MIL EXT 2.0 + CHA ' + whip.toUpperCase() + ' + LZ SLOPER WIRE · MPAS 2.0 component path',
        { [hybrid]: 1, 'mil-ext': 1, [whip]: 1, 'lz-sloper': 1, 'vertical-artificial-return-path': 1, mount: 1, 'feedline-choke-path': 1 },
        [
          'This record names the actual MPAS 2.0 components; the complete CHA MPAS 2.0 retail system is not an additional component.',
          'Controlled stack, bottom to top: CHA ' + hybrid.toUpperCase() + ' feed/base, CHA MIL EXT 2.0, then CHA ' + whip.toUpperCase() + '; attach and strain-relieve the 60 ft LZ SLOPER WIRE at the whip tip.',
          'The feed point and integrated RFI choke remain at the base of the MIL EXT 2.0 assembly. Select and record the exact radial, counterpoise or bonded-body return at that feed point.',
          'Use only SS17 or SS25 above the MIL EXT 2.0 when the LZ SLOPER WIRE is installed. The LZ wire is not a stand-alone antenna.',
          'This extension-supported geometry requires its own named NEC case; do not substitute the accepted non-extension SS17 or SS25 LZ pattern.'
        ]);
    });
  });

  recipe('prv2-cap-hat-ss58', 'CHA MCC 2.0 + CHA CAP HAT + CHA SS58 · PRV 2.0 component path',
    { blank: 1, mcc: 1, 'cap-hat': 1, ss58: 1, 'ss-insulator': 1, 'vertical-artificial-return-path': 1, 'prv-compact-mount-path': 1, 'tuned-feedline-choke-path': 1 },
    [
      'This record names the actual PRV 2.0 components; the complete CHA PRV 2.0 retail system is not an additional component.',
      'Controlled stack, bottom to top: PRV 2.0 feed/base, MCC 2.0, CAP HAT, SS58.',
      'Place CHA SS INSULATOR below the artificial return/feed assembly when isolating natural ground or non-radiating conductive support hardware.',
      'The CAP HAT changes electrical length, current distribution, efficiency and the radiation pattern. Use only a pattern named for this complete stack.',
      'Available SS58 pattern references use a model-derived MCC electrical tuning state—not a physical MCC height setting. The selected SS58 remains installed and may be telescoped to change exposed length. Follow the PRV 2.0 guide for the separate SS58 6 m vertical OCFD configuration.'
    ]);

  ['ss17', 'ss58', 'mil-whip'].forEach(function (radiator) {
    recipe('mcc2-cap-hat-' + radiator, 'CHA MCC 2.0 + CHA CAP HAT + CHA ' + radiator.toUpperCase(),
      { blank: 1, mcc: 1, 'cap-hat': 1, [radiator]: 1, 'ss-insulator': 1, 'vertical-artificial-return-path': 1, [radiator === 'ss17' || radiator === 'ss25' ? 'prv-tall-mount-path' : 'prv-compact-mount-path']: 1, 'tuned-feedline-choke-path': 1 },
      [
        'Controlled mechanical stack, bottom to top: feed/base, CHA MCC 2.0, CHA CAP HAT, then the selected SS17, SS58 or CHA MIL WHIP 2.0.',
        'The stainless-steel CAP HAT hub provides the owner-confirmed bottom 3/8-24 male and top 3/8-24 female interfaces.',
        'Place CHA SS INSULATOR below the artificial return/feed assembly. The CAP HAT and any conductive extension above MCC 2.0 remain on the radiating side of that boundary.',
        'Mechanical compatibility does not select an MCC electrical state. Choose the operating band and return system before using pattern evidence.',
        radiator === 'mil-whip'
          ? 'Reviewed native cases cover the full deployed seven-section MIL WHIP 2.0 on 60, 40, 30, 20, and 17 meters. Each uses an independently converged, model-derived MCC electrical tuning state—not a customer-ready physical MCC height.'
          : 'Available pattern references use a model-derived MCC electrical tuning state—not a physical MCC height setting. Use the exact guide-defined SS17 or SS58 tuning procedure for the selected complete stack.'
      ]);
  });

  ['ss17', 'ss25', 'mil-whip'].forEach(function (radiator) {
    ['mini', 'micro'].forEach(function (hybridSize) {
      var hybrid = 'hybrid-' + hybridSize;
      var id = hybridSize === 'mini' ? 'mpas2-cap-hat-' + radiator : 'mpas2-micro-cap-hat-' + radiator;
      recipe(id, 'CHA ' + hybrid.toUpperCase() + ' + CHA MIL EXT 2.0 + CHA CAP HAT + CHA ' + radiator.toUpperCase() + ' · MPAS 2.0 component path',
        { [hybrid]: 1, 'mil-ext': 1, 'cap-hat': 1, [radiator]: 1, 'vertical-artificial-return-path': 1, mount: 1, 'feedline-choke-path': 1 },
        [
          'This record names the actual MPAS 2.0 components; the complete CHA MPAS 2.0 retail system is not an additional component.',
          'Controlled stack, bottom to top: CHA ' + hybrid.toUpperCase() + ' feed/base, MIL EXT 2.0, CAP HAT, then the selected SS17, SS25 or MIL WHIP 2.0.',
          'The CAP HAT changes electrical length, current distribution, efficiency and the radiation pattern. Use only a pattern named for this complete stack.',
          radiator === 'mil-whip'
            ? 'Reviewed native evidence is available for the exact MIL EXT 2.0 + CAP HAT + MIL WHIP 2.0 stack with named 25 ft radial and elevated-counterpoise returns on 80, 60, and 40 meters.'
            : 'Reviewed native evidence is available for this exact full-length SS17 or SS25 stack with separately named 25 ft ground-radial and elevated-counterpoise returns on 80, 60, and 40 meters. Do not transfer another radiator’s pattern.'
        ]);
    });
  });

  [15, 20, 25].forEach(function (height) {
    recipe('vertical-porta-mast-' + height, 'Chameleon vertical on ' + height + ' ft CHA PORTA-MAST',
      { 'porta-mast': 1, 'porta-mast-adapter': 1 },
      [
        'The insulated 3/8-24 top interface is the antenna feed/support boundary; the anodized-aluminium mast is not part of the radiator in this controlled model.',
        'Select the exact vertical, return system and ' + height + ' ft support height before using NEC evidence.',
        'This heavy mast is suited to base, HOA or vehicle-supported operation—not practical man-portable use.'
      ]);
    recipe('tdl-porta-mast-' + height, 'CHA TDL on ' + height + ' ft CHA PORTA-MAST',
      { 'porta-mast': 1, 'porta-mast-adapter': 1 },
      [
        'Mount CHA TDL at the electrically insulated 3/8-24 top interface.',
        'Use a governed TDL case named for the ' + height + ' ft support; the support height changes the ground interaction and pattern.'
      ]);
    recipe('wire-transformer-porta-mast-' + height, 'Wire-antenna transformer supported by ' + height + ' ft CHA PORTA-MAST',
      { 'porta-mast': 1 },
      [
        'Use the controlled Swivel Ring plus halyard/carabiner attachment. Do not clamp an unapproved bracket to the mast tubing.',
        'The mast supports the transformer; it does not define the wire geometry. Record wire bearings, endpoints, feedpoint height and ground clearance.'
      ]);
    recipe('wire-end-sloper-porta-mast-' + height, 'Wire-antenna endpoint supported by ' + height + ' ft CHA PORTA-MAST',
      { 'porta-mast': 1 },
      [
        'Use the controlled Swivel Ring plus halyard/carabiner attachment to support a wire end and form a sloper.',
        'Record which end is elevated, its bearing and both endpoint heights before selecting a pattern.'
      ]);
  });

  intelligence.configuration_governance = {
    revision: '1.4.0',
    approved: '2026-08-15',
    lz_sloper: { allowed_whips: ['CHA SS17', 'CHA SS25'], allowed_support_stacks: ['direct compatible feed/base', 'CHA MIL EXT 2.0 below the selected whip'], prohibited: ['standalone', 'CHA SS58', 'CHA MIL WHIP 2.0'] },
    cap_hat: {
      prv2_stack: ['CHA PRV 2.0 feed/base', 'CHA MCC 2.0', 'CHA CAP HAT', 'CHA SS58'],
      mcc2_stack: ['feed/base', 'CHA MCC 2.0', 'CHA CAP HAT', 'CHA SS17 or CHA SS58 or CHA MIL WHIP 2.0'],
      mpas2_stack: ['CHA HYBRID-MINI feed/base', 'CHA MIL EXT 2.0', 'CHA CAP HAT', 'CHA SS17 or CHA SS25 or CHA MIL WHIP 2.0']
    },
    radiator_components: {
      universal_rule: 'CHA SS17, CHA SS25, CHA SS58 and CHA MIL WHIP 2.0 are radiator components, not complete stand-alone antennas or independent feed systems. A 3/8-24 mechanical connection alone is insufficient.',
      ss17: {
        role: 'Telescopic radiator',
        permitted_complete_system_paths: ['CHA HYBRID-MINI feed/base', 'CHA HYBRID-MICRO feed/base', 'CHA BLANK in a governed CHA BV configuration', 'CHA M-COIL chain with its governed base/feed assembly', 'documented CHA MIL EXT 2.0 stack connected to its governed base/feed assembly'],
        prohibited: ['stand-alone radiator with no base feed point']
      },
      ss25: {
        role: 'Telescopic radiator',
        permitted_complete_system_paths: ['CHA HYBRID-MINI feed/base', 'CHA HYBRID-MICRO feed/base', 'CHA BLANK in a governed CHA BV configuration', 'CHA M25-COIL chain with its governed base/feed assembly', 'documented CHA MIL EXT 2.0 stack connected to its governed base/feed assembly'],
        prohibited: ['stand-alone radiator with no base feed point']
      },
      ss58: {
        role: 'Short telescopic radiator used principally with CHA MCC 2.0',
        permitted_complete_system_paths: ['CHA MCC 2.0 in a governed CHA PRV 2.0 stack', 'CHA MCC 2.0 + CHA CAP HAT in a governed complete stack'],
        prohibited: ['stand-alone radiator with no CHA MCC 2.0 or other explicitly governed base/feed assembly']
      },
      mil_whip_2_0: {
        role: 'Seven-section military radiator component',
        permitted_complete_system_paths: ['directly attached to a governed base/feed assembly', 'above CHA MIL EXT 2.0 when the extension is connected to its governed base/feed assembly', 'above CHA MCC 2.0 or CHA CAP HAT only in an explicitly governed complete stack'],
        feed_boundary: 'At the 3/8-24 radiator base for a direct governed feed assembly, or at the base of CHA MIL EXT 2.0 when the extension is present.',
        prohibited: ['stand-alone radiator with no governed base/feed assembly']
      }
    },
    extension_components: {
      products: ['CHA MIL EXT 2.0', 'CHA SINGLE EXT', 'CHA SINGLE-EXT SHORT'],
      quantity_boundary: {
        'CHA MIL EXT 2.0': 'Use the exact governed section count for the named configuration.',
        'CHA SINGLE EXT': 'One or two units may be used when the named configuration permits them.',
        'CHA SINGLE-EXT SHORT': 'One or two units may be used when the named configuration permits them.'
      },
      radiator_side: {
        definition: 'Conductive extension section above the electrical feed point and below an upper SS17, SS25, MCC 2.0, MIL WHIP 2.0 or SS58 stack component.',
        model_role: 'Part of the governed radiating conductor geometry.'
      },
      prohibited: ['installation below the electrical feed point', 'mechanical-mast classification', 'feed-or-matching classification', 'undefined upper radiator', 'using a neighboring configuration’s pattern']
    },
    porta_mast: {
      heights_ft: [15, 20, 25],
      rf_boundary: 'Electrically insulated 3/8-24 top; aluminium mast excluded from the radiator model.',
      fixed_mounts: ['TOP MOUNT', 'SIDE MOUNT', 'GROUND SLEEVE'],
      vehicle_mounts: ['HITCH MOUNT', 'WHEEL MOUNT'],
      top_mount_role: 'Horizontal structure such as a wooden deck or concrete slab.',
      side_mount_role: 'Side of a suitable structure.',
      guying: 'No guy wires are required when the mast is installed with a documented mount and operated within the controlled wind-area and survival limits.',
      classification: 'Heavy base/HOA/vehicle-supported mast; not practical man-portable equipment.'
    },
    stationary_vehicle_support: {
      mount: 'CHA HITCH MOUNT or CHA WHEEL MOUNT supporting a CHA PORTA-MAST, or either mount supporting CHA CFM-34 HD through CHA 34HD REDUCER KIT.',
      mount_positions: ['CHA HITCH MOUNT', 'CHA WHEEL MOUNT'],
      required_support_chains: ['vehicle mount + CHA PORTA-MAST + documented antenna attachment', 'vehicle mount + CHA 34HD REDUCER KIT + CHA CFM-34 HD + documented 3/8-24 top attachment'],
      prohibited_mounts: ['direct attachment of CHA BLANK', 'direct attachment of CHA HYBRID-MINI', 'direct attachment of CHA HYBRID-MICRO', 'direct attachment of CHA MCC 2.0', 'bumper mount', 'roof mount', 'rear bed rail mount', 'operator-supplied vehicle mount'],
      rf_returns: ['two 25 ft wire radials', 'CHA FSR X return'],
      axes: '+X vehicle-forward; +Y driver-side/left; +Z up; two wire radials on +Y and −Y; CHA FSR arms in the four diagonal quadrants.',
      rf_return: 'A named radial or counterpoise system remains part of the antenna and is deployed from the feed point.',
      vehicle_role: 'Mechanical support and nearby conductive environment; not an assumed replacement for the selected return system.',
      choke: 'Directly at the whip base, or at the base of MIL EXT 2.0 when the extension is installed.'
    }
  };
})();
